import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccordionStateService {
  private componentState = new Map<string, any>();
  clearStateHappened = new Subject<string[]>();

  // Save state for a component
  saveState(componentId: string, state: any): void {
    this.componentState.set(componentId, state);
  }

  // Retrieve state for a component
  getState<T>(componentId: string): T | undefined {
    return this.componentState.get(componentId);
  }

  // Clear state for a component
  clearState(componentId: string): void {
    this.componentState.delete(componentId);
  }

  // Clear states for a list of components
  bulkClearState(componentIds: string[]): void {
    componentIds.forEach((id) => this.componentState.delete(id));
    this.clearStateHappened.next(componentIds);
  }
}
